import { initFirebase } from './notifications'

var ga_client_id = '';
setTimeout(function() {
	if (typeof(ga) != 'undefined')
	ga(function() {
		var trackers = ga.getAll();
		if (trackers) {
			ga_client_id = trackers[0].get('clientId')
		}
	});

	window.ga_fcm = ga_client_id
	try {
		initFirebase()
	} catch (e) {
		console.error(e)
	}
}, 1000);